import React from 'react'
import PropTypes from 'prop-types'
import HeadingAlpha from '../headings/heading-alpha'
import InputAmount from '../forms/input-amount'
import PillRadios from '../forms/pill-radios'
import CtaButton from '../buttons/cta-button'
import FlatButton from '../buttons/flat-button'
import ModalWrapper from '../modal/modal-wrapper'
import Subtitle from '../texts/subtitle'
import Notification from '../notifications/notification'

const BidItem = props => {
  const {
    initialBid,
    currentBidAmount,
    userBid,
    minIncrementAmount,
    limitMinIncrementAmount,
    minIncrementPercentageText,
    isInitialBid,
    handleClose,
    handleBid,
    increaseUserBid,
    decreaseUserBid,
    handleAmountChange,
    isBetting,
    firstBidShortcutAmount,
    setFirstIncrementUserBid,
    secondBidShortcutAmount,
    setSecondIncrementUserBid,
    thirdBidShortcutAmount,
    setThirdIncrementUserBid,
    isBidButtonDisabled,
    isDecreaseButtonDisabled,
    isAuctionLive,
    makeABidText,
    currentBidIsText,
    initialBidIsText,
    minimumIncrementIsText,
    ofInitialBidText,
    upToAMaximumOfText,
    // addAutomaticBidText,
    bidText,
    cancelText,
    shippingChargeText
  } = props
  return (
    <ModalWrapper onClose={handleClose}>
      <HeadingAlpha>{makeABidText}</HeadingAlpha>
      <Subtitle
        hasEmphasisText
        number={isInitialBid ? initialBid : currentBidAmount}
      >
        {isInitialBid ? initialBidIsText : currentBidIsText}
      </Subtitle>
      <InputAmount
        theme='light-theme'
        leftControlDisabled={isDecreaseButtonDisabled}
        onClickRight={increaseUserBid}
        onClickLeft={decreaseUserBid}
        onChange={handleAmountChange}
        value={userBid}
      />
      <div className='bottom-space'>
        <PillRadios
          light
          name='bidIncrementShortcuts'
          items={[
            {
              label: `$${firstBidShortcutAmount}`,
              onClick: setFirstIncrementUserBid,
              checked: userBid === firstBidShortcutAmount
            },
            {
              label: `$${secondBidShortcutAmount}`,
              onClick: setSecondIncrementUserBid,
              checked: userBid === secondBidShortcutAmount
            },
            {
              label: `$${thirdBidShortcutAmount}`,
              onClick: setThirdIncrementUserBid,
              checked: userBid === thirdBidShortcutAmount
            }
          ]}
        />
      </div>
      <div className='full-width'>
        <CtaButton
          isLoading={isBetting}
          disabled={isBidButtonDisabled}
          onClick={handleBid}
          text={bidText}
        />
      </div>
      <div className='full-width'>
        {/* <FlatButton text={addAutomaticBidText} /> */}
      </div>
      {!isAuctionLive && (
        <div className='full-width'>
          <Notification iconName='warning' status='error'>
            <span>Sorry, the auction is already closed.</span>
          </Notification>
        </div>
      )}
      {shippingChargeText && (
        <Notification iconName='warning' status='neutral'>
          <p> {shippingChargeText} </p>
        </Notification>
      )}
      {!isInitialBid && (
        <Notification iconName='info' status='neutral'>
          <p>
            {minimumIncrementIsText} ${minIncrementAmount}.
            <br />
            ({`${minIncrementPercentageText} ${ofInitialBidText} $${initialBid},`}
            <br />
            {limitMinIncrementAmount &&
              ` ${upToAMaximumOfText} $${limitMinIncrementAmount}`}
            ).
          </p>
        </Notification>
      )}
      <div className='full-width'>
        <FlatButton text={cancelText} onClick={handleClose} />
      </div>
    </ModalWrapper>
  )
}

BidItem.propTypes = {
  initialBid: PropTypes.number,
  currentBidAmount: PropTypes.number,
  minIncrementAmount: PropTypes.number.isRequired,
  minIncrementPercentageText: PropTypes.string.isRequired,
  limitMinIncrementAmount: PropTypes.number,
  isInitialBid: PropTypes.bool.isRequired,
  userBid: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleBid: PropTypes.func.isRequired,
  increaseUserBid: PropTypes.func.isRequired,
  decreaseUserBid: PropTypes.func.isRequired,
  handleAmountChange: PropTypes.func.isRequired,
  isBetting: PropTypes.bool.isRequired,
  firstBidShortcutAmount: PropTypes.number.isRequired,
  setFirstIncrementUserBid: PropTypes.func.isRequired,
  secondBidShortcutAmount: PropTypes.number.isRequired,
  setSecondIncrementUserBid: PropTypes.func.isRequired,
  thirdBidShortcutAmount: PropTypes.number.isRequired,
  setThirdIncrementUserBid: PropTypes.func.isRequired,
  isBidButtonDisabled: PropTypes.bool.isRequired,
  isDecreaseButtonDisabled: PropTypes.bool.isRequired,
  isAuctionLive: PropTypes.bool.isRequired,
  // translations
  makeABidText: PropTypes.string.isRequired,
  currentBidIsText: PropTypes.string.isRequired,
  initialBidIsText: PropTypes.string.isRequired,
  minimumIncrementIsText: PropTypes.string.isRequired,
  ofInitialBidText: PropTypes.string.isRequired,
  upToAMaximumOfText: PropTypes.string.isRequired,
  addAutomaticBidText: PropTypes.string.isRequired,
  bidText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  shippingChargeText: PropTypes.string
}

export default BidItem



// WEBPACK FOOTER //
// ./src/ui/views/bid-item.js